import { toast } from "react-toastify";

export const AgeCalculation = (value, hiring_type) => {
  const today = new Date();
  const birthDate = new Date(value.split("/").reverse().join("-"));

  const month = today.getMonth() - birthDate.getMonth();
  let age = today.getFullYear() - birthDate.getFullYear();

  if (month < 0 || (month === 0 && today.getDate() < birthDate.getDate()))
    age--;

  if ((hiring_type === 1 && age < 16) || (hiring_type !== 1 && age < 18))
    return true;

  return false;
};

export const contactTypeNumber = (cntt) => {
  switch (cntt) {
    case "Whatsapp":
      return 1;
    case "Ligação":
      return 2;
    case "Presencial":
      return 3;
    case "E-mail":
      return 4;
    default:
      return cntt;
  }
};

export const statusToNumber = (stts) => {
  switch (stts) {
    case "Em aberto":
      return 1;
    case "Iniciado":
      return 2;
    case "Em análise":
      return 3;
    case "Documentos pendentes":
      return 4;
    case "Em processo admissão":
      return 5;
    case "Aprovado":
      return 6;
    case "Reprovado":
      return 7;
    case "Aguardando Assinatura":
      return 8;
    case "Finalização Cadastral":
      return 10;
    default:
      return 1;
  }
};

export const documentNumber = (doc) => {
  switch (doc) {
    case "RG":
      return 1;
    case "CNH":
      return 2;
    case "Passaporte":
      return 3;
    case "CTPS":
      return 4;
    case "CDI":
      return 5;
    case "RNE":
      return 6;
    default:
      return doc;
  }
};

export const genderNumber = (val) => {
  switch (val) {
    case "Masculino":
      return 1;
    case "Feminino":
      return 2;
    default:
      return val;
  }
};

export const validateCooperatedFields = ({
  identification_documents,
  address_proofs,
  income_proofs,
  subscription_cards,
  full_name,
  cpf,
  birth_date,
  document_number,
  issuing_body,
  document_uf,
  pa_id,
  issue_date,
  nationality,
  birth_city,
  birth_uf,
  mothers_name,
  email,
  phone,
  contact,
  cep,
  street,
  number,
  state,
  neighborhood,
  city,
}) => {
  if (!full_name) {
    toast.warning("O campo Nome Completo é obrigatório");

    return false;
  }

  if (!email) {
    toast.warning("O campo E-mail é obrigatório");

    return false;
  }

  if (!cpf) {
    toast.warning("O campo CPF é obrigatório");

    return false;
  }

  if (!birth_date) {
    toast.warning("O campo Data de Nascimento é obrigatório");

    return false;
  }

  /**
   * @description Documents
   * @argument if to validate is create or update
   */
  if (identification_documents && !identification_documents?.length) {
    toast.warning(
      "O(s) arquivo(s) Frente e Verso do Documento de Identificação é obrigatório."
    );

    return false;
  }

  if (address_proofs && !address_proofs?.length) {
    toast.warning("O(s) arquivo(s) Comprovante de Residência é obrigatório.");

    return false;
  }

  if (income_proofs && !income_proofs?.length) {
    toast.warning("O(s) arquivo(s) Comprovante de Renda é obrigatório.");

    return false;
  }

  if (subscription_cards && !subscription_cards?.length) {
    toast.warning("O(s) arquivo(s) Ficha de Interesse é obrigatório.");

    return false;
  }
  // ==============

  if (!document_number) {
    toast.warning("O campo Número do Documento é obrigatório");

    return false;
  }

  if (!issuing_body) {
    toast.warning("O campo Órgão Emissor é obrigatório");

    return false;
  }

  if (!document_uf) {
    toast.warning("O campo UF é obrigatório");

    return false;
  }

  if (!issue_date) {
    toast.warning("O campo Data de Emissão é obrigatório");

    return false;
  }

  if (!nationality) {
    toast.warning("O campo Nacionalidade é obrigatório");

    return false;
  }

  if (!birth_city) {
    toast.warning("O campo Cidade de Nascimento é obrigatório");

    return false;
  }

  if (!birth_uf) {
    toast.warning("O campo UF de Nascimento é obrigatório");

    return false;
  }

  if (!mothers_name) {
    toast.warning("O campo Nome da Mãe é obrigatório");

    return false;
  }

  if (!phone) {
    toast.warning("O campo Celular é obrigatório");

    return false;
  }

  if (!contact) {
    toast.warning("O campo Contato é obrigatório");

    return false;
  }

  if (!cep) {
    toast.warning("O campo CEP é obrigatório");

    return false;
  }

  if (!street) {
    toast.warning("O campo Rua é obrigatório");

    return false;
  }

  if (!number) {
    toast.warning("O campo Número (Endereço) é obrigatório");

    return false;
  }

  if (!state) {
    toast.warning("O campo UF (Endereço) é obrigatório");

    return false;
  }

  if (!neighborhood) {
    toast.warning("O campo Bairro é obrigatório");

    return false;
  }

  if (!city) {
    toast.warning("O campo Cidade é obrigatório");

    return false;
  }

  if (!pa_id) {
    toast.warning("O campo PA é obrigatório");

    return false;
  }

  if (
    !full_name ||
    !cpf ||
    !birth_date ||
    !document_number ||
    !issuing_body ||
    !document_uf ||
    !pa_id ||
    !issue_date ||
    !nationality ||
    !birth_city ||
    !birth_uf ||
    !mothers_name ||
    !email ||
    !phone ||
    !contact ||
    !cep ||
    !street ||
    !number ||
    !state ||
    !neighborhood ||
    !city
  ) {
    toast.warning("Preecha os dados obrigatórios");

    return false;
  }

  return true;
};

export const validateToReturn = ({
  identification_documents,
  marital_status,
  address_proofs,
  income_proofs,
  subscription_cards,
  full_name,
  social_name,
  cpf,
  pa_id,
  status,
  birth_date,
  document_number,
  issuing_body,
  document_uf,
  issue_date,
  nationality,
  birth_city,
  birth_uf,
  mothers_name,
  fathers_name,
  email,
  phone,
  contact,
  cep,
  street,
  number,
  state,
  complement,
  neighborhood,
  city,
  mailing_address,
  private_description,
  account_number,
  situation_document,
  reason_reprovation,
  responsible_email,
}) => {
  if (
    (identification_documents && identification_documents.length) ||
    (marital_status && marital_status.length) ||
    (address_proofs && address_proofs.length) ||
    (income_proofs && income_proofs.length) ||
    (subscription_cards && subscription_cards.length)
  ) {
    return true;
  }

  if (
    full_name ||
    social_name ||
    cpf ||
    pa_id ||
    status ||
    birth_date ||
    document_number ||
    issuing_body ||
    document_uf ||
    issue_date ||
    nationality ||
    birth_city ||
    birth_uf ||
    mothers_name ||
    fathers_name ||
    email ||
    phone ||
    contact ||
    cep ||
    street ||
    number ||
    state ||
    complement ||
    neighborhood ||
    city ||
    mailing_address ||
    private_description ||
    account_number ||
    situation_document ||
    reason_reprovation ||
    responsible_email
  ) {
    return true;
  }

  return false;
};
